import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import {
  BuildingFilterDto,
  BuildingItemDto,
  BuildingService,
  TenantItemDto, TenantService,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import TenantTypeEnum = BuildingFilterDto.TenantTypeEnum;
import { currentTenantId } from '@/utils/admin-utils';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-contractor-building-overview-page',
  templateUrl: './contractor-building-overview-page.component.html',
  styleUrls: ['./contractor-building-overview-page.component.scss'],
})
export class ContractorBuildingOverviewPageComponent {
  form!: FormGroup;

  readonly tenantService = inject(TenantService);

  currentTenantId = currentTenantId();

  fixedTenants = asyncComputed(() => {
    const tenantId = this.currentTenantId();
    if (tenantId) {
      return this.tenantService.findExternalTenantsByContractorId(tenantId);
    }
    return [];
  }, []);

  readonly loadBuildings = (filter: BuildingFilterDto) => this.buildingService.findAll({ ...filter, assignedContractorTenantId: this.currentTenantId() });
  readonly getCount = (filter: BuildingFilterDto) => this.buildingService.getCount({ ...filter, assignedContractorTenantId: this.currentTenantId() });

  constructor(private readonly router: Router,
    private readonly buildingService: BuildingService,
    private readonly formBuilder: FormBuilder,
  ) {
    this.form = this.formBuilder.group({
      fullTextSearch: this.formBuilder.control(''),
      ownerTenant: this.formBuilder.control<TenantItemDto | null>(null),
      ownerTenantId: this.formBuilder.control<string | null>(null),
    });

    this.form.get('ownerTenant')?.valueChanges.subscribe((tenant) => {
      if (tenant) {
        this.form.get('ownerTenantId')?.setValue(tenant.id);
      } else {
        this.form.get('ownerTenantId')?.setValue(null);
      }
    });
  }

  navigateToBuilding(event: BuildingItemDto): void {
    this.router.navigate(['building', event.id]);
  }

  protected readonly TenantTypeEnum = TenantTypeEnum;
  protected readonly signal = signal;
}
